import statesOptions from '../data/states.json';
import taxClassifications from '../data/taxClassifications.json';
import validations from '../data/validations.json';

CommissionAssignmentController.$inject = [
  'ApplicationService',
  '$scope',
  '$location',
  '$window',
  '$q'
];

function CommissionAssignmentController (ApplicationService, $scope, $location, $window, $q) {
  function init () {
    var formData = ApplicationService.getData();
    $scope.agencyInformation = formData.agencyInformation;
    $scope.brokerInformation = formData.brokerInformation;
    $scope.commissionInformation = formData.commissionInformation;
    $scope.taxClassifications = taxClassifications;
    $scope.validations = validations;
    $scope.statesOptions = statesOptions;
    $scope.submitForm = submitForm;
    $scope.previousStep = previousStep;
    $scope.addressErrorDetails = null;
  }

  $scope.editAddress = function () {
    $scope.addressErrorDetails = null;
    $window.scrollTo(0, 0);
  };

  $scope.selectAddress = function (address) {
    var commissionInformation = ApplicationService.getData().commissionInformation;
    if ($scope.addressErrorDetails.type === 'agency') {
      commissionInformation.assigneeAddress = address.address;
      commissionInformation.assigneeAddress2 = address.address2;
      commissionInformation.assigneeCity = address.city;
      commissionInformation.assigneeState = address.state;
      commissionInformation.assigneeZipCode = address.zipCode;
      $scope.skipAgencyValidation = true;
    } else {
      commissionInformation.finInstStreetAddress = address.address;
      commissionInformation.finInstStreetAddress2 = address.address2;
      commissionInformation.finInstCity = address.city;
      commissionInformation.finInstState = address.state;
      commissionInformation.finInstZipCode = address.zipCode;
      $scope.skipFinancialValidation = true;
    }
    $scope.commissionInformation = commissionInformation;
    nextStep();
  };

  function previousStep () {
    $location.path('/application/agency-information');
  }

  function submitForm (form) {
    $window.scrollTo(0, 0);
    if (form.$valid) {
      $scope.addressError = false;
      nextStep();
    }
  }

  function nextStep () {
    var data = {
      commissionInformation: $scope.commissionInformation
    };

    if (data.commissionInformation.assignee !== 'third_party') {
      // we don't want to save any of this data
      delete data.commissionInformation.assigneeName;
      delete data.commissionInformation.assigneeAddress;
      delete data.commissionInformation.assigneeAddress2;
      delete data.commissionInformation.assigneeCity;
      delete data.commissionInformation.assigneeState;
      delete data.commissionInformation.assigneeZipCode;
      delete data.commissionInformation.assigneePhone;
      delete data.commissionInformation.assigneeEmail;
      delete data.commissionInformation.assigneeTaxID;
      delete data.commissionInformation.taxClassification;
    } else {
      data.commissionInformation.assigneeAddress2 = (data.commissionInformation.assigneeAddress2 || '');
    }

    if (data.commissionInformation.payViaCheck) {
      delete data.commissionInformation.accountOwner;
      delete data.commissionInformation.finEmailAddress;
      delete data.commissionInformation.financialInstitutionName;
      delete data.commissionInformation.finInstStreetAddress;
      delete data.commissionInformation.finInstStreetAddress2;
      delete data.commissionInformation.finInstCity;
      delete data.commissionInformation.finInstState;
      delete data.commissionInformation.finInstZipCode;
      delete data.commissionInformation.routingNumber;
      delete data.commissionInformation.accountNumber;
    } else {
      data.commissionInformation.finInstStreetAddress2 = (data.commissionInformation.finInstStreetAddress2 || '');
    }

    // There used to be a value called "useDirectDeposit"
    // This value was the inverse of what it should have been
    data.commissionInformation.useDirectDeposit = data.commissionInformation.payViaCheck;

    ApplicationService.setData(data);

    $scope.loading = true;
    validateFinancialAddress()
      .then(validateAgencyAddress)
      .then(function () {
        $scope.loading = false;
        nextPage();
      }).catch(function () {
        $scope.loading = false;
      });
  }

  function validateAgencyAddress () {
    return $q(function (resolve, reject) {
      if ($scope.commissionInformation.assignee !== 'third_party' || $scope.skipAgencyValidation) {
        resolve();
      } else {
        ApplicationService.validateAddress({
          address: $scope.commissionInformation.assigneeAddress,
          address2: $scope.commissionInformation.assigneeAddress2,
          city: $scope.commissionInformation.assigneeCity,
          state: $scope.commissionInformation.assigneeState,
          zipCode: $scope.commissionInformation.assigneeZipCode
        }).then(function (response) {
          $scope.addressErrorDetails = null;
          resolve();
        }, function (response) {
          $scope.addressErrorDetails = response;
          $scope.addressErrorDetails.type = 'agency';
          reject();
        });
      }
    });
  }

  function validateFinancialAddress () {
    $scope.addressExplanation = '';
    return $q(function (resolve, reject) {
      // badly named:
      if ($scope.commissionInformation.payViaCheck || $scope.skipFinancialValidation) {
        resolve();
      } else {
        ApplicationService.validateAddress({
          address: $scope.commissionInformation.finInstStreetAddress,
          address2: $scope.commissionInformation.finInstStreetAddress2,
          city: $scope.commissionInformation.finInstCity,
          state: $scope.commissionInformation.finInstState,
          zipCode: $scope.commissionInformation.finInstZipCode
        }).then(function (response) {
          $scope.addressErrorDetails = null;
          resolve();
        }, function (response) {
          $scope.addressErrorDetails = response;
          $scope.addressErrorDetails.type = 'financial';
          reject();
        });
      }
    });
  }

  function nextPage () {
    $location.path('/application/producer-declaration');
  }

  init();
}

export default CommissionAssignmentController;



//////////////////
// WEBPACK FOOTER
// ./src/js/controllers/CommissionAssignmentController.js
// module id = 21
// module chunks = 0